export const STORAGE_KEYS = {
  cartItems: 'enfa_cart_items',
  tableContext: 'enfa_table_context',
  sessionContext: 'enfa_session_context',
  orders: 'enfa_orders',
} as const;

export const LEGACY_STORAGE_KEYS = {
  cartItems: ['enfa_client_cart_v1'],
  tableContext: ['enfa-table-number', 'enfa-table-label', 'enfa_table_number'],
  sessionContext: ['enfa-user', 'enfa-customer-ref'],
} as const;
